import { render } from "./shopAddMoney.vue?vue&type=template&id=6f38a241&scoped=true"
import script from "./shopAddMoney.vue?vue&type=script&lang=js"
export * from "./shopAddMoney.vue?vue&type=script&lang=js"

import "./shopAddMoney.vue?vue&type=style&index=0&id=6f38a241&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-manage/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f38a241"]])

export default __exports__